import { render, staticRenderFns } from "./hoursClosed_4.vue?vue&type=template&id=1f3d6960&scoped=true&"
import script from "./hoursClosed_4.vue?vue&type=script&lang=js&"
export * from "./hoursClosed_4.vue?vue&type=script&lang=js&"
import style0 from "./hoursClosed_4.vue?vue&type=style&index=0&id=1f3d6960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3d6960",
  null
  
)

export default component.exports